import { LoadablePaint } from '@confluence/loadable';

export const ErrorAppLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ErrorApp" */ './ErrorApp.tsx')).ErrorApp,
});
